export default "__VITE_ASSET__2Qcjx7z2__"